import { Carrier, Port, Route, Vessel } from './';

export class Schedule {

  public scheduleId: number;
  public scheduleIndex: number;
  public voyage: string;

  public eta: string;
  public etaTime: string;
  public etd: string;
  public etdTime: string;

  public carrier: Carrier;
  public port: Port;
  public route: Route;
  public vessel: Vessel;

  public portLinkParameters: { date: string, scroll: boolean };

  constructor(json: any) {
    this.scheduleId = json.schedule_id || 0;
    this.scheduleIndex = json.schedul_index || 0;
    this.voyage = json.voyage || '';

    this.eta = json.eta;
    this.etaTime = this.eta == ' - ' ? '' : (json.eta_time || '');

    this.etd = json.etd;
    this.etdTime = this.etd == ' - ' ? '' : (json.etd_time || '');

    this.carrier = new Carrier(json.carrier);
    this.port = new Port(json.port);
    this.route = new Route(json.route);
    this.vessel = new Vessel(json.vessel);

    this.portLinkParameters = { date: this.eta, scroll: true };
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/schedule.ts